import HttpHelper from './helper';


export const tournamentEndpoints = {
    getTournamentTree: (params,lang="ar") => HttpHelper.baseAxios
        .get('/tournament/tree', { params })
        .then((res) => res?.data)
        .catch((err) => err?.response?.data),
};
